import { observer } from 'mobx-react';
import { autoinject, Enums, humanizeString, inject, NothingHere } from 'Mri.Web.Common';
import * as React from 'react';
import { BiStore } from '../BI/BiStore';

export interface IReportedEventsTableProps {
    onClick(type: Mri.DisplayApi.DowntimeIncidentTypes, displays: string[]): any;
    readonly title?: string;
    readonly loading: boolean;
}

@autoinject
@observer
export class ReportedEventsTable extends React.Component<IReportedEventsTableProps> {
    public render() {
        return (
            <div className="h-100 d-flex flex-column">
                <p className="w-100 text-center mb-1">{this.props.title}</p>

                <div className="card flex-grow-1 px-2 overflow-y pt-0 pb-1">
                    <div className="container-fluid">
                        <div className="row f-12 my-0 p-1">
                            <div className="col-6 text-start">
                                <p className="mb-0">
                                    <b>Event Type</b>
                                </p>
                            </div>
                            <div className="col-6 text-center">
                                <p className="mb-0">
                                    <b>Displays Affected</b>
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 reported-events">
                                {this.biStore.sortedDisplayEventsTotals.slice(0, 10).map((g, idx) => (
                                    <a
                                        onClick={() => this.props.onClick(g.downtimeIncidentType, g.displays)}
                                        key={idx}
                                        className="row f-12 my-0 p-1"
                                    >
                                        <div className="col-6 text-start">
                                            <p className="mb-0">
                                                {humanizeString(
                                                    Enums.toString(
                                                        Enums.DowntimeIncidentType,
                                                        g.downtimeIncidentType
                                                    ).slice(9)
                                                )}
                                            </p>
                                        </div>

                                        <div className="col-6 text-center">
                                            <p className="mb-0">{g.displays.length}</p>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        </div>

                        <NothingHere
                            empty={!this.biStore.sortedDisplayEventsTotals.length}
                            label="No Reported Events"
                            loading={this.props.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }

    @inject
    private biStore!: BiStore;
}
